import React, { useState, useEffect } from 'react';
import { UseAxios } from '../Server-Api-Instance';
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  ThemeProvider,
} from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend
} from 'recharts';
import theme from '../Shared/theme.js';
import '../Shared/CommonStyle.css';

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const AgentCommissionChart = ({ username }) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noDataMessage, setNoDataMessage] = useState('');

  useEffect(() => {
    fetchData(year);
  }, [year]);

  const fetchData = async (selectedYear) => {
    setLoading(true);
    try {
      const axios = UseAxios(false); // Pass true to use local URL
      const response = await axios.post('/GetAgentCommissionDataByYear', {
        username,
        year: selectedYear,
      });
      const resultData = response.data;
      if (resultData.length === 0) {
        setNoDataMessage('No data available for the selected year.');
      } else {
        setNoDataMessage('');
      }
      setData(resultData);
    } catch (error) {
      console.error('Error fetching data', error);
      setNoDataMessage('Error fetching data.');
    } finally {
      setLoading(false);
    }
  };

  const roundToTwoDecimal = (value) => {
    return Math.round(value * 100) / 100;
  };

  const formatCurrency = (value) => {
    const formatted = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
    }).format(value);
    return formatted.replace('£', '£');
  };

  const chartData = monthNames.map((month, index) => {
    const match = data.find(d => d.Month === index + 1);
    return {
      month,
      sellAmount: match ? roundToTwoDecimal(match.SellAmount) : 0,
      agencyCommission: match ? roundToTwoDecimal(match.AgencyCommission) : 0,
    };
  });
  

  return (
    <ThemeProvider theme={theme}>
      <div className="header">
        <Box className="heading-box">AGENCY COMMISSION DATA</Box>
      </div>
      <Box display="flex" justifyContent="center" gap={2} mb={2}>
        <FormControl variant="outlined" className="year-select" sx={{ minWidth: 150 }}>
          <InputLabel>Departure Year</InputLabel>
         <Select
            sx={{
              '.MuiSvgIcon-root': { color: '#be9f55' },
            }}
            value={year}
            onChange={(e) => setYear(e.target.value)}
            label="Departure Year"
          >
            {Array.from({ length: 6 }, (_, i) => {
      const currentYear = new Date().getFullYear();
      // start from currentYear + 1 and go down
      const displayYear = currentYear + 2 - i;
      return (
        <MenuItem key={displayYear} value={displayYear}>
          {displayYear}
        </MenuItem>
      );
    })}
          </Select>
          {/* <Grid item xs={6} sm={3}>
  <TextField
    label="Departure Year"
    type="number"
    fullWidth
    value={year}
    onChange={(e) => setYear(e.target.value)}
    inputProps={{
      max: new Date().getFullYear(), 
      min: 2022 // optional, if you want to set a lower bound
    }}
  />
</Grid> */}
        </FormControl>
      </Box>
      <Box className="chart-container" sx={{ height: '410px', minHeight: '300px' }}>
      {loading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
             <BarChart data={chartData}>
           <CartesianGrid strokeDasharray="1 3" />
           
              <XAxis dataKey="month" />
              <YAxis
  width={72}
  tickFormatter={(value) => `£${value.toLocaleString(undefined, { minimumFractionDigits: 0 })}`}
/>

              <Tooltip 
               className="recharts-tooltip"
               formatter={(value) => formatCurrency(value)}
                labelFormatter={(label) => `Month: ${label}`} 
                contentStyle={{
                  backgroundColor: 'white',
                  border: '2px solid #BE9F55', // Border color
                
                  padding: '10px', // Padding
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Shadow
                  color: '#333', // Text color
                  fontSize: '14px', // Font size
                }}
              />
              <Legend />
              <Bar dataKey="sellAmount" fill="#BE9F55" />
              <Bar dataKey="agencyCommission" fill="#646464" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="no-data-message">
            {noDataMessage}
          </div>
        )
      )}
      </Box>
    </ThemeProvider>
  );
};

export default AgentCommissionChart;
